export interface AppConfig {
  minimalScoreToApply: number;
  gqlApiUrl: string;
  portalRootId: string;
  clarityProjectId: string;
  sentryDsn: string;
  cognito: {
    linkedInCustomProviderName: string;
    region: string;
    userPoolId: string;
    clientId: string;
    domain: string;
    redirectSignIn: string;
    redirectSignOut: string;
  };
  google: {
    autocompleteKey: string;
    recaptchaKey: string;
  };
  realtimerUrl: string;
  airporterUrl: string;
  jobBoardUrl: string;
  discordUrl: string;
  cv: {
    maxSize: number;
    minSize: number;
    acceptedTypes: string[];
  };
  allowUserWithFinishedOnboardingBackToOnboarding: boolean;
  isAIREnabled: boolean;
}

export const appConfig: AppConfig = {
  minimalScoreToApply: import.meta.env.VITE_MINIMAL_SCORE_TO_APPLY || 0,
  gqlApiUrl: import.meta.env.VITE_GRAPHQL_API_URL || 'http://localhost:4000/graphql',
  jobBoardUrl: import.meta.env.VITE_JOB_BOARD_URL,
  portalRootId: 'portal-root',
  clarityProjectId: import.meta.env.VITE_CLARITY_PROJECT_ID,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  cognito: {
    linkedInCustomProviderName: import.meta.env.VITE_COGNITO_LINKED_IN_CUSTOM_PROVIDER_NAME,
    region: import.meta.env.VITE_COGNITO_REGION,
    userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
    clientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
    domain: import.meta.env.VITE_COGNITO_DOMAIN,
    redirectSignIn: import.meta.env.VITE_COGNITO_REDIRECT_SIGN_IN,
    redirectSignOut: import.meta.env.VITE_COGNITO_REDIRECT_SIGN_OUT,
  },
  google: {
    autocompleteKey: import.meta.env.VITE_GOOGLE_AUTOCOMPLETE_KEY,
    recaptchaKey: import.meta.env.VITE_GOOGLE_RECAPTCHA_KEY,
  },
  realtimerUrl: import.meta.env.VITE_REALTIMER_URL ?? 'https://api.dev.c-hub.hoq.us',
  airporterUrl: import.meta.env.VITE_AIRPORTER_URL ?? 'https://airporter.dev.air.connectis.pl',
  discordUrl: import.meta.env.VITE_DISCORD_URL,
  cv: {
    maxSize: 5000000,
    minSize: 1,
    acceptedTypes: [
      'application/pdf',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'application/vnd.openxmlformats',
      'application/doc',
      'application/ms-doc',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ],
  },
  allowUserWithFinishedOnboardingBackToOnboarding:
    import.meta.env.VITE_ALLOW_USERS_WITH_FINISHED_ONBOARDING_BACK_TO_ONBOARDING === 'true',
  isAIREnabled: import.meta.env.VITE_IS_AIR_ENABLED === 'true',
};
